import {Redirect} from "react-router-dom"
import Loading from "@irati/ui/src/Loading"
import {useFlexiMigration} from "@irati/wallet/hooks/flexiMigration"
import React from "react"
import {useAppRouteContext} from "@irati/utils/history"
import {FLEXIREWARDS} from "@irati-web/app/src/routeConfig"
import Markdown from "@irati/ui/src/Markdown"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {ButtonLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import {walletTracking} from "@irati-tracking/wallet"
import FlexiImg from "../images/flexi_flexi_flexi.svg"

export function PointsConversionMaintenance() {
  const {load, status} = useFlexiMigration()
  const {apps} = useAppRouteContext()
  const {formatMessage} = useIntl()
  return (
    <Loading inline load={load}>
      {status === "MID" ? (
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100%"
          gap={4}
          style={{
            minHeight: "calc(100vh - 300px)",
            textAlign: "center"
          }}>
          <img src={FlexiImg} alt="" />
          <Markdown source="wallet.pointsConversion.scheduledMaintenance" />
          <ButtonLink
            onClick={(e) => {
              walletTracking.clickPointsSimplifcationLearnMore({source: "maintenance_window"})
              e.stopPropagation()
            }}
            primary
            href={formatMessage({id: "wallet.pointsConversion.learnLink"})}
            target="_blank">
            <FormattedMessage id="platform.cta.learnMore" />
          </ButtonLink>
        </Flex>
      ) : (
        <Redirect to={apps[FLEXIREWARDS]} />
      )}
    </Loading>
  )
}
